module.exports = __webpack_public_path__ + "static/img/phone-slider.f063495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-slider.png
// module id = F/wc
// module chunks = 1